import { createFeatureSelector } from '@ngrx/store';

import {
  PackageResultModuleState,
  packageResulFeatureName
} from '@packages/packages-result/store/state/packages-result-module.state';

export const packagesResultRootSelector = createFeatureSelector<PackageResultModuleState>(packageResulFeatureName);
